<template>
  <div id="app">
    <Header v-if="!this.$route.meta.noHeader && isPC && isHeader"></Header>
    <mobile-header v-if="!this.$route.meta.noHeader && !isPC && isHeader"></mobile-header>
    <div class="app-inner">
      <router-view />
    </div>
    <el-backtop v-if="isPC"></el-backtop>
    <Footer v-if="!this.$route.meta.noFooter"></Footer>
  </div>
</template>

<script>
import { isPC } from '@/utils/getIsPC'
import Header from '@/pages/components/header'
import mobileHeader from './pages/components/mobileHeader'
import Footer from '@/pages/components/footer'
import Cookie from 'js-cookie'
export default {
  name: 'App',

  components: {
    Header,
    Footer,
    mobileHeader
  },
  data () {
    return {
      StoreUrl: '',
      isShow: false,
      BuyDetail: '',
      isPC: true,
      isHeader: true
    }
  },
  created () {
    this.isPC = isPC()
    this.StoreUrl = Cookie.get('StoreUrl')
    this.BuyDetail = Cookie.get('BuyDetail')
    this.Bus.$off('routerShop-app')
    this.Bus.$on('routerShop-app', data => {
      // console.log('app-routerShop', data)
      this.StoreUrl = data.StoreUrl
      this.BuyDetail = data.BuyDetail
    })
    this.Bus.$off('routerShop-app-show')
    this.Bus.$on('routerShop-app-show', is => {
      this.isShow = is
    })
    window.addEventListener('scroll', this.handleScroll)
    this.Bus.$off('course-header')
    this.Bus.$on('course-header', val => {
      this.isHeader = val
    })
  }
}
</script>

<style>
@import "assets/fontFile/font.css";
#app {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #fff;
  font-family: Bobofont;
}
.app-inner{
  flex: 1;
  display: flex;
  /*background-color: #fff;*/
  box-sizing: border-box;
}
.ma-label .cell {
  padding: 0 !important;
}
.el-backtop{
  right: 10px !important;
  bottom: 15px !important;
  box-shadow: 0 0 6px rgba(0,0,0,.8);
}
</style>



// WEBPACK FOOTER //
// src/App.vue